import dayjs from "dayjs";
import "dayjs/locale/th";
import "dayjs/locale/th";
import relativeTime from "dayjs/plugin/relativeTime";
import { t } from "i18next";
dayjs.extend(relativeTime);
dayjs.locale("th");

export const FormatTimeAgo = (pastTime) => {
  if (!pastTime) {
    return "N/A";
  }
  const past = dayjs(pastTime);
  const now = dayjs();
  const diffSeconds = now.diff(past, "second");
  const diffMinutes = now.diff(past, "minute");
  const diffHours = now.diff(past, "hour");
  const diffDays = now.diff(past, "day");
  const diffMonths = now.diff(past, "month");
  const diffYears = now.diff(past, "year");
  if (diffSeconds < 1) {
    return t("just now");
  } else if (diffSeconds < 60) {
    return `${diffSeconds} ${t("second ago")}`;
  } else if (diffMinutes < 2) {
    return `${diffMinutes} ${t("minute ago")}`;
  } else if (diffMinutes < 60) {
    return `${diffMinutes} ${t("minute ago")}`;
  } else if (diffHours < 2) {
    return `1 ${t("hour ago")}`;
  } else if (diffHours < 24) {
    return `${diffHours} ${t("hour ago")}`;
  } else if (diffDays < 2) {
    return `1 ${t("day ago")}`;
  } else if (diffDays < 30) {
    return `${diffDays} ${t("day ago")}`;
  } else if (diffMonths < 2) {
    return `1 ${t("Last month")}`;
  } else if (diffMonths < 12) {
    return `${diffMonths} ${t("Last month")}`;
  } else if (diffYears < 2) {
    return `1 ${t("last year")}`;
  } else {
    return `${diffYears} ${t("last year")}`;
  }
};
export const calculateTimeDifference = (startDate, endDate) => {
  // 1. ตรวจสอบเบื้องต้นว่ามีค่าส่งมาหรือไม่
  if (!startDate || !endDate) {
    return "-";
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  // 2. ตรวจสอบว่าเป็น Invalid Date หรือไม่ (ถ้าคำนวณไม่ได้ getTime จะได้ NaN)
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return "-";
  }

  const differenceInSeconds = Math.floor(
    (end.getTime() - start.getTime()) / 1000,
  );

  // 3. ตรวจสอบกรณีที่เวลาติดลบ (ถ้า end มาก่อน start)
  if (differenceInSeconds < 0) {
    return "-";
  }

  if (differenceInSeconds < 60) {
    return `${differenceInSeconds} ${t("s")}`;
  } else if (differenceInSeconds < 60 * 60) {
    const minutes = Math.floor(differenceInSeconds / 60);
    const remainingSeconds = differenceInSeconds % 60;
    return `${minutes} ${t("mins")}${
      remainingSeconds > 0 ? ` ${remainingSeconds} ${t("s")}` : ""
    }`;
  } else if (differenceInSeconds < 60 * 60 * 24) {
    const hours = Math.floor(differenceInSeconds / (60 * 60));
    const remainingMinutes = Math.floor((differenceInSeconds % (60 * 60)) / 60);
    return `${hours} ${t("hours")}${
      remainingMinutes > 0 ? ` ${remainingMinutes} ${t("mins")}` : ""
    }`;
  } else if (differenceInSeconds < 60 * 60 * 24 * 30) {
    const days = Math.floor(differenceInSeconds / (60 * 60 * 24));
    return `${days} ${t("days")}`;
  } else if (differenceInSeconds < 60 * 60 * 24 * 365) {
    const months = Math.floor(differenceInSeconds / (60 * 60 * 24 * 30));
    return `${months} ${t("months")}`;
  } else {
    // แก้ไขเงื่อนไขสุดท้ายให้ครอบคลุมปี
    const years = Math.floor(differenceInSeconds / (60 * 60 * 24 * 365));
    return `${years} ${t("years")}`;
  }
};

// export const calculateTimeDifference = (startDate, endDate) => {
//   const start = new Date(startDate);
//   const end = new Date(endDate);
//   const differenceInSeconds = Math.floor(
//     (end.getTime() - start.getTime()) / 1000
//   );
//   if (differenceInSeconds < 60) {
//     return `${differenceInSeconds} ${t("s")}`;
//   } else if (differenceInSeconds < 60 * 60) {
//     const minutes = Math.floor(differenceInSeconds / 60);
//     const remainingSeconds = differenceInSeconds % 60;
//     return `${minutes} ${t("mins")}${
//       remainingSeconds > 0 ? ` ${remainingSeconds} ${t("s")}` : ""
//     }`;
//   } else if (differenceInSeconds < 60 * 60 * 24) {
//     const hours = Math.floor(differenceInSeconds / (60 * 60));
//     const remainingMinutes = Math.floor((differenceInSeconds % (60 * 60)) / 60);
//     return `${hours} ${t("hours")}${
//       remainingMinutes > 0 ? ` ${remainingMinutes} ${t("mins")}` : ""
//     }`;
//   } else if (differenceInSeconds < 60 * 60 * 24 * 30) {
//     // ประมาณ 30 วันต่อเดือน
//     const days = Math.floor(differenceInSeconds / (60 * 60 * 24));
//     return `${days} ${t("days")}`;
//   } else if (differenceInSeconds < 60 * 60 * 24 * 365) {
//     // ประมาณ 365 วันต่อปี
//     const months = Math.floor(differenceInSeconds / (60 * 60 * 24 * 30));
//     return `${months} ${t("months")}`;
//   } else if (differenceInSeconds > 60 * 60 * 24 * 365) {
//     const years = Math.floor(differenceInSeconds / (60 * 60 * 24 * 365));
//     return `${years} ${t("years")}`;
//   } else {
//     return `-`;
//   }
// };
